<template>
  <div class="page">
    <a-card :bordered="false" :bodyStyle="{padding:'0px'}" :headStyle="{borderBottom:'0px',padding:'0px'}">
      <a-row slot="title">
        <a-col :span="24">
          <span class="card-title">{{ authorizationId == 1 ? '您尚未授权微信公众号' : '基本信息' }} </span>
        </a-col>
      </a-row>
      <template v-if="authorizationId==1">
        <a-row class="mb15">
          1、已注册开通微信公众号，请点击下方&lt;授权微信公众号&gt;按钮，用公众号管理员的微信扫码授权即可。
        </a-row>
        <a-row class="mb15">
          <a-button @click="onAuthorEvent">授权微信公众号</a-button>
        </a-row>
        <a-row class="mb15">2、尚未注册微信公众号帐号，可前往<a href="https://mp.weixin.qq.com/"
                                                              target="_blank">微信公众平台</a>注册公众号，然后再回到该页面进行授权。
          <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;若您不会注册微信公众号，可右上角联系您的专属客户经理提供协助。
        </a-row>
      </template>
      <template v-if="authorizationId==2">
        <a-form-model :label-col="currentFormLayout.labelCol" :wrapper-col="currentFormLayout.wrapperCol">
          <a-form-model-item label="公众号名称" style="margin-bottom:5px;">
            <span>{{ ruleForm.nickName }}</span>
          </a-form-model-item>
          <a-form-model-item label="公众号AppID" style="margin-bottom:5px;">
            <span>{{ ruleForm.appId }}</span>
          </a-form-model-item>
          <a-form-model-item label="公众号logo">
            <CustomImage :imageUrl="ruleForm.headImg" :width="80" :height="80"></CustomImage>
          </a-form-model-item>
          <a-form-model-item label="公众号类型" style="margin-bottom:5px;">
            <span>{{ ruleForm.serviceTypeText }}</span>
          </a-form-model-item>
          <a-form-model-item label="主体名称" style="margin-bottom:5px;">
            <span>{{ ruleForm.principalName }}</span>
          </a-form-model-item>
          <a-form-model-item label="微信认证" style="margin-bottom:5px;">
            <span>{{ ruleForm.verifyTypeText }}</span>
          </a-form-model-item>
          <a-form-model-item label="公众号二维码">
            <!-- 二维码下载组件 -->
            <QrCodeModule :type="1"></QrCodeModule>
          </a-form-model-item>
        </a-form-model>
      </template>
    </a-card>
  </div>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import QrCodeModule from './QrCodeModule'

export default {
  name: 'WeChat',
  mixins: [ruleFormMixins],
  components: {
    QrCodeModule
  },
  data() {
    return {
      authorizationId: '',
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      merchantName: '',
      appId: '',
      preAuthCode: '',
      ruleForm: {
        annualReview: '',// 是否需要年审 ,
        annualReviewBeginTime: '',// 年审开始时间 ,
        annualReviewBeginTimeStr: '',// 年审开始时间Str ,
        annualReviewEndTime: '',// 年审结束时间 ,
        annualReviewEndTimeStr: '',// 年审结束时间Str ,
        appId: '',// appId ,
        headImg: '',// logo ,
        id: '',// id ,
        name: '',// 名称 ,
        namingVerify: '',// 是否名字认证 ,
        principalName: '',// 主体名称 ,
        qrcodeUrl: '',// 二维码地址 ,
        qualificationVerify: '',//是否资质认证 ,
        qualificationVerifyText: '',
        serviceType: '',// 公众号类型 ,
        serviceTypeText: '',// 公众号类型文本 ,
        signature: '',// 功能介绍 ,
        status: '',// 状态 1：已授权，2：已失效 ,
        verifyType: ''// 公众号认证类型
      },
      auth_code: this.$route.query.auth_code ? this.$route.query.auth_code : null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getWechatAccount()
    })
  },
  methods: {
    // 获取APPid(接口取消)
    getWechatAppId() {
      this.getHttpServices().getUserService().get('api/v2/wx/auth/getConfig').then(res => {
        this.getLogUtils().logWithTag('==getWechatAppId==', res)
        this.appId = res.componentAppId
        this.preAuthCode = res.preAuthCode
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取详情
    getWechatAccount() {
      this.getHttpServices().getUserService().post('api/v2/wx/auth/account/detail', {
        type: 1,
        platformId: this.platformId,
        merchantId: this.merchantId
      }).then(res => {
        this.getLogUtils().logWithTag('==getWechatAccount==', res)
        if (res) {
          this.authorizationId = 2
          this.ruleForm = res
          if (this.ruleForm.status == 2) {
            this.authorizationId = 1
            this.getMerchantInformation()
          }
        } else {
          this.authorizationId = 1
          this.getMerchantInformation()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 去授权页面
    onAuthorEvent() {
      let path = '/users/authorization?merchantId=' + this.merchantId + '&type=1&platformId=' + this.platformId + '&merchantName=' + this.merchantName
      let domainName = ''
      const platformConfig = this.$store.getters.platformConfig
      if (this.platformId == 1) {
        domainName = location.origin
      } else {
        // domainName = "https://b.mofangx.com";
        // domainName = "https://admin2.test.mofangx.com";
        domainName = platformConfig.domainNameUrl
      }
      if (domainName) {
        location.href = domainName + path
      }
    },
    // 接口取消
    onEvent() {
      let url = location.origin + '/platform/manager/officials'
      let authorUrl = 'https://mp.weixin.qq.com/cgi-bin/componentloginpage?component_appid=' + this.appId + '&pre_auth_code=' + this.preAuthCode + '&redirect_uri=' + encodeURIComponent(url) + '&auth_type=1'
      // window.open(authorUrl)
      location.href = authorUrl
    },
    // 接口取消
    authorization() {
      this.getHttpServices().getUserService().post('api/v2/wx/auth/user/authorization', {
        authorizationCode: this.auth_code,
        type: 1
      }).then(res => {
        this.getLogUtils().logWithTag('==authorization==', res)
        this.getWechatAccount()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //运营商数据
    getMerchantInformation() {
      this.getHttpServices().getUserService().get('backstage/homepage/get/merchantInformation')
        .then(res => {
          this.merchantName = res.merchantName
          this.getLogUtils().logWithTag('运营商概况', res)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style lang="less" scoped>
.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.mb15 {
  margin-bottom: 15px;
}
</style>